import React, { useEffect, useState } from "react";
import styles from "./SortComponent.module.scss";
import { BlackTriangleUp, OrangeTriangleDown } from "../../../../assets/icons";

type Props = {
	onSortChange: (queryParams: string) => void
};

enum SortType {
	POPULAR = 'numberOfViews',
	LATEST = 'createdAt',
	PRICE = 'price'
	
}

const SortComponent: React.FC<Props> = (props: Props) => {
	const [ checkedSort, setCheckSort ] = useState('price')
	const [ sort, setSort ] = useState('asc'); 

	// Function to handle filter changes
	const onComponentFilterChange = () => {

		// Generate query string
		const queryParams = new URLSearchParams();

		queryParams.append('sortBy', checkedSort);
		queryParams.append('sortOrder', sort);
  
		// Convert query parameters to a string
		const queryString = queryParams.toString();
		
		props.onSortChange(queryString);	
		};

	useEffect(() => {
		onComponentFilterChange()
	}, [checkedSort, sort])

	const changeSortType = (value: string) => {
		switch (value) {
			case SortType.POPULAR:
				if (value == checkedSort) changeSortOrder();
				else {
					setCheckSort(SortType.POPULAR)
					setSort('asc')
				}
				break;
			case SortType.LATEST:
				if (value == checkedSort) changeSortOrder();
				else {
					setCheckSort(SortType.LATEST)
					setSort('asc')
				}
				break;
			case SortType.PRICE:
				if (value == checkedSort) changeSortOrder();
				else {
					setCheckSort(SortType.PRICE)
					setSort('asc')
				}
				break;
			default:
				break;
		}
	}

	const changeSortOrder = () => {
		sort == 'desc' ? setSort('asc') : setSort('desc');
	}


	return (
		<div className={styles.mainContainer}>
			<div className={styles.sortByText}>
				Sort by
			</div>
			<div className={styles.sortButtons}>
				<div className={`${styles.leftEdgesSort} ${checkedSort == SortType.POPULAR ? styles.grayBackground : null}`} onClick={() => changeSortType(SortType.POPULAR)}>
					Popular
					{
						checkedSort == SortType.POPULAR ? 
						<span>
							{
								sort == 'asc' ?
									<span>
										<BlackTriangleUp/>
										<OrangeTriangleDown/>
									</span>
								:
									<span>
										<OrangeTriangleDown/>
										<BlackTriangleUp/>
									</span>
							}
						</span>
						: null
					}
				</div>
				<div className={`${styles.middleSort} ${checkedSort == 'Latest' ? styles.grayBackground : null}`} onClick={() => changeSortType(SortType.LATEST)}>
					Latest
					{
						checkedSort == SortType.LATEST ? 
						<span>
							{
								sort == 'asc' ?
									<span>
										<BlackTriangleUp/>
										<OrangeTriangleDown/>
									</span>
								:
									<span>
										<OrangeTriangleDown/>
										<BlackTriangleUp/>
									</span>
							}
						</span>
						: null
					}
				</div>
				<div className={`${styles.rightEdgesSort} ${checkedSort == SortType.PRICE ? styles.grayBackground : null}`} onClick={() => changeSortType(SortType.PRICE)}>
					Price
					{
						checkedSort == SortType.PRICE ? 
						<span>
							{
								sort == 'asc' ?
									<span>
										<BlackTriangleUp/>
										<OrangeTriangleDown/>
									</span>
								:
									<span>
										<OrangeTriangleDown/>
										<BlackTriangleUp/>
									</span>
							}
						</span>
						: null
					}
					
				</div>
			</div>
		</div>
	);
};

export default SortComponent;
